import { StatementLinesModel } from "@gerrieDev/Services/GerrieApiModels";
import { GetStatementLinesApiParameter, GetStatementsApiParameter } from "@gerrieDev/Services/StatementService";
import { StatementLinesState } from "@gerrieDev/Store/Data/StatementLines/StatementLinesState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

const initialStatementLinesState: StatementLinesState = {
    isLoading: false,
    value: undefined,
    dataLoaded: false,
};

const reducer = {

    "Data/Statement/BeginLoadStatementLines": (draft: Draft<StatementLinesState>) => {
        draft.isLoading = true;
    },

    "Data/Statement/CompleteLoadStatementLines": (
        draft: Draft<StatementLinesState>,
        action: { parameter: GetStatementLinesApiParameter; collection: StatementLinesModel },
    ) => {
        draft.isLoading = false;
        draft.value = action.collection;
        draft.dataLoaded = true;
    },

    "Data/Statement/ResetLines": () => {
        return initialStatementLinesState;
    },
};

export default createTypedReducerWithImmer(initialStatementLinesState, reducer);
